import {createActions} from "redux-actions";

const socketActions = createActions({
    RECEIVE_MESSAGE: undefined,
    CONNECTED: undefined,
    REMOVE_MESSAGES: undefined,
});

export default socketActions;
